import { render, staticRenderFns } from "./NotifyDetailPanel.vue?vue&type=template&id=76900b9e&scoped=true&"
import script from "./NotifyDetailPanel.vue?vue&type=script&lang=js&"
export * from "./NotifyDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotifyDetailPanel.vue?vue&type=style&index=0&id=76900b9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76900b9e",
  null
  
)

export default component.exports